import { ProfileType } from '../../../common/enums/ProfileType';
import { Profile } from './valueObjects/Profile';

export class FuzzerProfile extends Profile {
  static blank() {
    return new FuzzerProfile(0, '', ProfileType.FUZZER, false, new Set());
  }
}
